var map = {
	"./menu/dashboard-color.svg": 127,
	"./menu/dashboard.svg": 170,
	"./menu/logoutmobile.svg": 128,
	"./menu/overview-color.svg": 129,
	"./menu/overview.svg": 171,
	"./menu/payments-color.svg": 130,
	"./menu/payments.svg": 172,
	"./menu/settings-color.svg": 131,
	"./menu/settings.svg": 173,
	"./menu/settlement-color.svg": 132,
	"./menu/settlement.svg": 174,
	"./menu/tools-color.svg": 133,
	"./menu/tools.svg": 175,
	"./menu/withdrawals-color.svg": 134,
	"./menu/withdrawals.svg": 176
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 713;